<div class="accordion__container">
  <form [formGroup]="group">
    <div class="accordion__grid">
      <div>
        <mat-form-field>
          <mat-label>Name of Company / Owner of Accounts</mat-label>
          <input matInput formControlName="name" id="name" type="text" [readonly]="true" title="Company Name" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Organisation Type</mat-label>
          <mat-select formControlName="organisationTypeString" id="organisationTypeString" title="Organisation Type">
            @for (type of organisationTypes; track $index) {
              <mat-option [value]="type.value">{{ type.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Current Trading Name</mat-label>
          <input matInput formControlName="currentTradingName" id="currentTradingName" type="text" title="Current Trading Name" />
        </mat-form-field>
      </div>
    </div>
    <div class="accordion__grid">
      <div>
        <mat-form-field>
          <mat-label>Previous Trading Name</mat-label>
          <input matInput formControlName="previousTradingName" id="previousTradingName" type="text" title="Previous Trading Name" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Company Registration Number</mat-label>
          <input matInput formControlName="registrationNumber" id="registrationNumber" type="text" title="Company Registration Number" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Website</mat-label>
          <input matInput formControlName="website" id="website" type="text" title="Website" />
          <mat-error comFormMessageName="website">A valid url is required</mat-error>
        </mat-form-field>
      </div>
    </div>
    <h3>Document Preferences</h3>
    <div class="radio">
      <div>
        <mat-radio-group formControlName="deliveryMethod" id="deliveryMethod" aria-label="Select an option">
          <mat-label comFormLabelName="deliveryMethod"><b>Delivery Method</b></mat-label>
          <mat-radio-button value="1">Electronic</mat-radio-button>
          <mat-radio-button value="0">Paper</mat-radio-button>
        </mat-radio-group>
      </div>
      <div>
        <mat-radio-group formControlName="languagePreference" id="languagePreference" aria-label="Select an option">
          <mat-label comFormLabelName="languagePreference"><b>Language</b></mat-label>
          <mat-radio-button checked value="0">English</mat-radio-button>
          <mat-radio-button value="1">Irish</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="accordion__buttons">
      @if (group.disabled) {
        <button mat-raised-button type="button" (click)="edit(group)" [disabled]="!canEdit">EDIT</button>
      }
      @if (isError) {
        <div [innerHtml]="errorMessages | arrayToList"></div>
      }
      @if (!group.disabled) {
        <button mat-raised-button (click)="cancel(group)" type="button">CANCEL</button>
        <button mat-raised-button [disabled]="!group.valid" (click)="save(group.value)" type="button">UPDATE</button>
      }
    </div>
  </form>
</div>
